import img1 from "../assets/img/project-1.jpg";
import img2 from "../assets/img/project-2.jpg";
import img3 from "../assets/img/project-3.jpg";
import img4 from "../assets/img/project-4.jpg";
import img5 from "../assets/img/project-5.jpg";
import img6 from "../assets/img/project-6.jpg";

export const imageData = [
  { image: img1 },
  { image: img2 },
  { image: img3 },
  { image: img4 },
  { image: img5 },
  { image: img6 },
];
